import { Core } from "@faire/design-tokens";
import styled, { css, keyframes } from "styled-components";

const anim = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

export const GhostBlock = styled.div<{
  $width?: string;
  $height?: string;
  $borderRadius?: string;
  $aspectRatio?: string;
}>`
  width: ${(props) => props.$width ?? "100%"};
  height: ${(props) => props.$height ?? "100%"};
  background-color: ${Core.surface.subdued};
  animation: ${anim} 2s ease-out infinite;
  cursor: progress;
  border-radius: ${(props) => props.$borderRadius ?? "0%"};
  ${(props) =>
    props.$aspectRatio
      ? css`
          aspect-ratio: ${props.$aspectRatio};
        `
      : ""}
`;
